<template>
  <div class="pointer" @click="OrderDown()">
    <img src="@/assets/images/elements/iconDown.svg" alt="" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "../../../../util/backend";
import baseUrl from "../../../../util/baseUrl";

export default {
  computed: {
    ...mapGetters({
      pointer: "general/pointer"
    })
  },

  methods: {
    async OrderDown() {
      let config;
      switch (this.pointer) {
        case "video":
          config = {
            method: "put",
            url: `${baseUrl.baseurl()}/VideoOrderDown`,
            data: {
              video_id: this.params.value
            }
          };
          await axios.api(config).then(async res => {
            res.status === 200
              ? await this.$store.dispatch(
                  "general/getCourseDetail",
                  this.$route.params.id
                )
              : alert("order fail");
          });
          break;

        case "banner":
          config = {
            method: "put",
            url: `${baseUrl.baseurl()}/bannerOrderDown`,
            data: {
              banner_id: this.params.value
            }
          };
          await axios.api(config).then(async res => {
            res.status === 200
              ? await this.$store.dispatch("general/get_bannerTable")
              : alert("order fail");
          });
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
